module.exports = __webpack_public_path__ + "static/media/make-your-mark.04561401.svg";